module.exports = __webpack_public_path__ + "img/FILE.b8b0e70c.png";